import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from '../../../../dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { StageSettingsState } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/stage-settings/stage-settings.state';
import _ from 'lodash';
import { SamwinUserStatusSelectors } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.selectors';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';
import {
   ChangeShowCallInfo,
   ChangeShowHistory,
   ChangeShowDefaultBackground,
   ChangeShowNextDialTarget,
} from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/stage-settings/stage-settings.actions';
import { map } from 'rxjs/operators';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';

@Component({
   selector: 'samweb-stage-settings',
   templateUrl: './stage-settings.component.html',
   styleUrls: ['./stage-settings.component.scss'],
})
export class StageSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   public brickInstanceId: string;

   public showHistory$: Observable<boolean>;
   public showCallInfo$: Observable<boolean>;
   public showNextDialTarget$: Observable<boolean>;
   public showDefaultBackground$: Observable<boolean>;

   @Select(SamwinUserStatusSelectors.getAllSelectableStatusInfos)
   public samwinUserStates$: Observable<UserStatusInfoRemoteDto[]>;

   @Select(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.SAMWIN_7_ATTENDANT))
   public featureEnabled$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.showHistory$ = this.store.select(StageSettingsState.getShowHistory).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showCallInfo$ = this.store.select(StageSettingsState.getShowCallInfo).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showNextDialTarget$ = this.store.select(StageSettingsState.getShowNextDialTarget).pipe(map((fn) => fn(this.brickInstanceId)));
      this.showDefaultBackground$ = this.store.select(StageSettingsState.getShowDefaultBackground).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeShowCallInfo(checked: boolean) {
      this.store.dispatch(new ChangeShowCallInfo(this.brickInstanceId, checked));
   }

   changeShowHistory(checked: boolean) {
      this.store.dispatch(new ChangeShowHistory(this.brickInstanceId, checked));
   }

   changeShowNextDialTarget(checked: boolean) {
      this.store.dispatch(new ChangeShowNextDialTarget(this.brickInstanceId, checked));
   }

   changeShowDefaultBackground(checked: boolean) {
      this.store.dispatch(new ChangeShowDefaultBackground(this.brickInstanceId, checked));
   }
}
